import { gatewayClient } from 'utils/gatewayClient';

export interface FetchCipApplicationResponse {
  bankApplicationDocuments: Array<{
    address: {
      street: string;
      city: string;
      state: string;
      postalCode: string;
      country: string;
    };
    bankApplicationDocumentId: string;
    bankApplicationDocumentType: string;
    bankApplicationId: string;
    description: string;
    name: string;
    status: string;
  }>;
  bankApplicationStatus: string;
  bankApplicationFormUrl: string;
  bankApplicationSubmittedAt: string;
}

export const fetchCipApplication = () =>
  gatewayClient.get<never, FetchCipApplicationResponse>(
    '/banking/v1/member/applications/latest'
  );
